var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_4",
    "data-name": "Artboard \\u2013 4",
    clipPath: "url(#clip-Artboard_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#b3b9bb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "suitcase_1_",
    "data-name": "suitcase (1)",
    transform: "translate(43 50)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M41.471,23.517a4.783,4.783,0,0,1-4.782-4.782V11.563H17.563v7.172a4.782,4.782,0,0,1-9.563,0V11.563A9.573,9.573,0,0,1,17.563,2H36.689a9.573,9.573,0,0,1,9.563,9.563v7.172A4.783,4.783,0,0,1,41.471,23.517Z",
    transform: "translate(30.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M60.773,29.6a9.849,9.849,0,0,1-3.395.574A10.477,10.477,0,0,1,53.7,29.5L0,11.62V48.1A13.142,13.142,0,0,0,13.149,61.252h88.458A13.142,13.142,0,0,0,114.756,48.1V11.62Z",
    transform: "translate(0 36.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M114.756,18.149V29.1L58.526,47.842a3.538,3.538,0,0,1-2.3,0L0,29.1V18.149A13.142,13.142,0,0,1,13.149,5h88.458A13.142,13.142,0,0,1,114.756,18.149Z",
    transform: "translate(0 11.345)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusiness);
export default __webpack_public_path__ + "static/media/icon-business.6fd180760090fbd044a22b5721295312.svg";
export { ForwardRef as ReactComponent };